import React from "react";
import {Card} from "../../shared_lib/bootstrap/card/Card";
import sampleImgCard from "../../assets/img/icon.png";
import {IconLabel} from "../../shared_lib/bootstrap/icon/IconLabel";
import {AppModel} from "../../models/appModel";
import {useTranslation} from "react-i18next";

const CardContent = ({
                         data,
                         goToLinkHandler,
                     }: {
    data: AppModel;
    goToLinkHandler: (id: string) => void;
}) => {
    const {t} = useTranslation();

    return (
        <div className={"mb-3"}>
            <Card
                heading={
                    <div
                        className={"d-flex align-items-center justify-content-center overflow-hidden p-5"}
                        style={{
                            backgroundImage:
                                "linear-gradient(135deg, #F1F5F7 0%, #DCE6EB 100%)",
                            'minHeight': '200px'
                        }}
                    >
                        <img
                            src={data.image} /*data.image*/
                            className=""
                            style={{maxHeight: "200px", objectFit: "contain"}}
                        />
                    </div>
                }
                title={data.title}
            >
                <div style={{'minHeight': '128px'}} className={'d-flex flex-column'}>
                    <p>{data.description}</p>
                    <div
                        className={"pointer mt-auto"}
                        onClick={() => goToLinkHandler(data.url)}
                    >
                        <IconLabel
                            iconRight={"arrow-right"}
                            label={t("action.goIt").toUpperCase()}
                            labelClass={"text-primary mt-1"}
                        />
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default CardContent;
